import React from 'react';
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  Container,
} from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OffRoadAdventuresExperiencesSection/OffRoadAdventuresExperiencesSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import Typography500 from 'views/common/components/UI/Typography500';
import { RiCheckFill } from 'react-icons/ri';

const OffRoadAdventuresExperiencesSection = () => {
  const content = useContent('OffRoadLandingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  return (
    <StyledBox>
      <Container>
        <Grid container spacing={8}>
          <Grid item lg={6} md={12} sm={12}>
            <Box className="OAESImage">
              <ImgBox
                image={{
                  src: getSizedImage(content.adventuresExprienceBackground),
                  alt: content.adventuresExprienceBackground.alt,
                }}
                width="100%"
                height="100%"
                unoptimized
              />
              <Box className="OAESSubImg">
                <ImgBox
                  image={{
                    src: getSizedImage(content.adventuresExprienceSubBackground),
                    alt: content.adventuresExprienceSubBackground.alt,
                  }}
                  width="100%"
                  height="100%"
                  unoptimized
                />
              </Box>
            </Box>
          </Grid>
          <Grid item lg={6} md={12} sm={12}>
            <Typography variant="h3" component="h2">
              {content.adventuresTitle}
            </Typography>
            <Typography
              variant="body1"
              component="p"
              color="text.secondary"
              my={2}>
              {content.adventuresDescription}
            </Typography>
            <List>
              {content.adventuresDescriptionList.map((advanture) => (
                <ListItem
                  className="OAESListItem"
                  key={advanture.benefitText}
                  disableGutters>
                  <RiCheckFill className="OAESIcon" />
                  <Typography500
                    component="p"
                    variant="body1"
                    color="text.secondary"
                    className="OAESBenfites"
                    dangerouslySetInnerHTML={{
                      __html: advanture.benefitText,
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { OffRoadAdventuresExperiencesSection };
